<template>
  <div class="fixed z-50 inset-0 overflow-y-auto" id="upload-evidence">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-800 opacity-75"></div>
      </div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div v-if="!hasUploaded">
          <!-- Close Icon -->
          <div class="absolute top-0 right-0 pt-4 sm:pt-6 pr-4 sm:pr-6">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <span class="sr-only">Close</span>
              <svg class="h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <h3 class="text-lg leading-6 font-medium text-gray-900 -mt-0.5">
            Uploading Evidence
          </h3>

          <img class="inline-block w-full max-w-full h-auto rounded-md mt-4" src="/assets/images/cloud-file-upload-using-css.gif" />

          <table class="min-w-full divide-y divide-gray-200 mt-4 border">
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="evidence in evidences" v-bind:key="evidence.uid">
                <td class="px-2 py-1.5">
                  <div v-if="evidence.evidence_type_id==1">
                    <div class="text-sm text-gray-900">Cosmetic Issue: </div>
                    <div class="text-xs text-gray-500">{{evidence.description}}</div>
                  </div>
                  <div v-if="evidence.evidence_type_id==2">
                    <div class="text-sm text-gray-900">Repair Issue: </div>
                    <div class="text-xs text-gray-500">{{evidence.description}}</div>
                  </div>
                  <div v-if="evidence.evidence_type_id==3">
                    <div class="text-sm text-gray-900">Closing Disclosure/Settlement Statement</div>
                  </div>
                  <div v-if="evidence.evidence_type_id==4">
                    <div class="text-sm text-gray-900">Appraisal</div>
                  </div>
                  <div v-if="evidence.evidence_type_id==5">
                    <div class="text-sm text-gray-900">Other Issue: </div>
                    <div class="text-xs text-gray-500">{{evidence.description}}</div>
                  </div>
                </td>
                <td class="px-2 py-1.5 text-right">
                  <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" v-if="evidence.updateStatus == 0">Waiting</div>
                  <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" v-if="evidence.updateStatus == 1">
                    <i class="fa fa-spinner fa-spin mr-0.5"></i> Uploading
                  </div>
                  <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" v-if="evidence.updateStatus == 2">
                    <i class="fa fa-check mr-0.5"></i> Done
                  </div>
                  <div class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" v-if="evidence.updateStatus == 3">
                    <i class="fa fa-warning mr-0.5"></i> Error
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <template v-if="hasUploaded">
            <template v-if="admin">
                  <div>
                      <!-- Icon check -->
                      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                        <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <div class="mt-3 text-center sm:mt-5">
                          <h3 class="text-lg leading-6 font-medium text-gray-900">
                            Evidence Uploaded!
                          </h3>
                      </div>
                    </div>
                    <div class="mt-5 sm:grid-cols-2 sm:mt-6 text-center">
                      <button type="button" @click="redirectToAdminEvidences()" class="bg-indigo-600 border border-transparent inline-block focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 font-medium hover:bg-indigo-700 justify-center px-2 sm:px-8 py-2 w-full sm:w-auto rounded-md shadow-sm text-sm text-white">
                        Back To Evidences
                      </button>
                    </div>
            </template>
            <template v-else>
            <div>
              <!-- Icon check -->
              <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-5">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Thank you for your patience
                  </h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      Congratulations, you have successfully sent us your tax protest evidence. We will be in touch with you via email regarding the progress of your protest. In some cases it takes the appraisal district months to complete all of our protests.
                    </p>
                  </div>
              </div>
            </div>
            <div class="mt-5 sm:grid-cols-2 sm:mt-6 text-center">
              <button type="button" @click="redirectToEvidences()" class="bg-indigo-600 border border-transparent inline-block focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 font-medium hover:bg-indigo-700 justify-center px-2 sm:px-8 py-2 w-full sm:w-auto rounded-md shadow-sm text-sm text-white">
                Done
              </button>
            </div>
            </template>
        </template>


      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import ProtestRequestApi from "../../../../../services/api/AdminProtestRequest.js";
import { siteUrl } from "../../../../../config/base.js";

export default {
  props: ["protestRequest", "evidences","admin"],

  data() {
    return {
      hasUploaded: false,
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init(){
      for (let index = 0; index < this.evidences.length; index++) {
        let evidence = this.evidences[index];
        evidence['uploadingEvidnece'] = true;
        let i = this.evidences.findIndex(
        (e) => evidence.uid === e.uid
        );
        this.evidences.splice(i, 1, evidence);
      }
      setTimeout(()=>this.initUpload(),2000);
    },

    initUpload() {
      for (var i = 0; i < this.evidences.length; i++) {
        let evidence = this.evidences[i];
        let evidenceFormData = this.getFormData(evidence);

        ProtestRequestApi.storeEvidences(
            this.protestRequest.uid,
            evidenceFormData,
            this.admin
        )
        .then((res) => {
            if (res.data.error) {
              alert("Something went wrong.");
              console.log(res.data.message);
              return;
            }

            for (let index = 0; index < this.evidences.length; index++) {
              let evidence = this.evidences[index];
              if(evidence.uid === res.data.evidenceUid){
                evidence['uploadingEvidnece'] = false;
                let i = this.evidences.findIndex(
                  (e) => evidence.uid === e.uid
                  );
                  this.evidences.splice(i, 1, evidence);
                  break;
              }
            }

          })
          .catch(function (error) {
            alert("Something went wrong.");
            throw new Error(error);
        });
      }
    },

    getFormData(evidence) {
      let formData = new FormData();


      for (var key in evidence) {
        if (key == "uploads") {
          let uploads = evidence[key];
          let fileOrSavedFileId = null;
          for (var j = 0; j < uploads.length; j++) {
            fileOrSavedFileId = uploads[j].id ? uploads[j].id : uploads[j];
            formData.append(
              "data[files][" + key + "][" + j + "]",
              fileOrSavedFileId
            );
          }
          delete evidence["uploads"];
        }
        //
        else if (key == "invoice") {
          let value = "";
          if (!evidence[key]) {
            value = "";
          } else if (evidence[key].id) {
            value = evidence[key].id;
          } else {
            value = evidence[key]; //file
          }
          formData.append("data[files][" + key + "]", value);
          delete evidence["invoice"];
        } else if (key == "appraisal_date") {
          let value = evidence[key]
            ? moment(evidence[key]).format("YYYY-MM-DD")
            : null;
          evidence[key] = value;
        }
      }
      formData.append("data[fields]", JSON.stringify(evidence));
      return formData;
    },

    redirectToEvidences() {
      window.location.href = siteUrl + "/protest-requests/" + this.protestRequest.uid + "/evidences/approval/";
    },
    redirectToAdminEvidences(){
       window.location.href = siteUrl + "/admin/protest-requests/" + this.protestRequest.uid + "/evidences/show";
    }
  },
  watch: {
    evidences:{
      deep:true,
      handler: function (val, oldVal) {
        const uploadingEvidnece = true;
        const count = val.filter((obj) => obj.uploadingEvidnece === uploadingEvidnece).length;
        console.log('count of evidence uploading');
        console.log(count);
        if(count == 0){
          this.hasUploaded = true;
        }
      },

    }
  },
};
</script>
